import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer style={footer}>
      <div style={inner}>
        <span style={copy}>© {new Date().getFullYear()} WorldRTT. All rights reserved.</span>
        <div style={links}>
          <Link to="/terms" style={link}>Terms</Link>
          <Link to="/privacy" style={link}>Privacy</Link>
        </div>
      </div>
    </footer>
  );
}

const footer: React.CSSProperties = {
  borderTop: "1px solid rgba(255,255,255,0.07)",
  padding: "24px",
  marginTop: "auto",
};
const inner: React.CSSProperties = {
  maxWidth: 1100,
  margin: "0 auto",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 12,
};
const copy: React.CSSProperties = {
  color: "#98A1AB",
  fontSize: 13,
};
const links: React.CSSProperties = {
  display: "flex",
  gap: 20,
};
const link: React.CSSProperties = {
  color: "#98A1AB",
  fontSize: 13,
  textDecoration: "none",
};
